export default {
  addKeyModal: {
    action: 'Zastosuj',
    errorMessage:
      'Błąd podczas stosowania klucza. Jeśli problem nie ustąpi, skontaktuj się z zespołem pomocy Metrica Sports',
    minutesMessage: 'Twój klucz został przetworzony. Masz teraz %{minutes} minut dostępnych.',
    placeholder: 'Wpisz klucz...',
    successMessage: 'Klucz został pomyślnie zastosowany',
    title: 'Dodaj klucz'
  },
  admin: {
    NoGames: 'Brak gier, dodaj swoją pierwszą...',
    NoResults: 'Brak wyników...',
    addKey: 'Dodaj klucz',
    atd: 'ATD',
    automatedTrackingData: 'Automatyczny Tracking Danych (ATD)',
    automatedTrackingDataJobSuccess:
      'Proces Automatycznego Przetwarzania Danych Tracking na %{vpName} został zakończony i jest teraz dostępny w Metrica PlayBase',
    automatedTrackingDataProcessedTooltip: 'Przetwarzane zautomatyzowane dane śledzenia',
    awayTeam: 'Drużyna gości',
    awayTeamScore: 'Wynik drużyny gości',
    ballDetection: 'Wykrywanie piłki',
    ballTracking: 'Tracking Piłki',
    ballTrackingProcessedTooltip: 'Przetworzono wykrywanie piłki',
    ballTrackingTooltip:
      'Ten proces wykryje piłkę i pozwoli Ci ją zobaczyć w ramach Live Formation (boisko 2D) w PlayBase. Koordynaty piłki będą również dostępne w pliku w formacie FIFA EPTS.',
    cancelATDProcessSuccessfully: 'Automatyczny Tracking Danych został anulowany w %{vpName}',
    cancelDataIntegrationProcessSuccessfully: 'Proces integracji danych został anulowany %{vpName}',
    cancelEventsProcessSuccessfully: 'Proces Smart Tagging został anulowany w %{vpName}.',
    cancelProcessTooltip: 'Anuluj proces',
    cancelSurfacesProcessSuccessfully: 'Przetwarzanie powierzchni zostało anulowane w %{vpName}',
    cancelTrackingFifaFormatProcessSuccessfully:
      'Tracking formatu FIFA został anulowany w %{vpName}',
    category: 'Kategoria',
    checking: 'Sprawdzanie…',
    cloudMinutes: 'Minuty GameCloud',
    competition: 'Rozgrywki',
    connectionFailed: 'Połączenie nie powiodło się',
    connectionFailedText:
      'Wygląda na to, że wystąpił problem z pobraniem aktualnych informacji. Sprawdź połączenie internetowe i ponownie załaduj stronę. Jeśli problem będzie się powtarzał, skontaktuj się z pomocą techniczną',
    correctedTracking: 'Tracking Correction Processing',
    correctionUsage: 'Czy będziesz używać tego Video Project do korekty Trackingu?',
    correctionUsageTooltip:
      'Tracking Correction Manager (TCM) to moduł w PlayBase skierowany do użytkownika, służący do korygowania ścieżek graczy wygenerowanych wcześniej za pomocą naszego ATD, który automatycznie generuje dane bez identyfikatorów dla dowolnego meczu piłki nożnej. Użyj TCM, aby poprawić błędne ścieżki i przypisać im tożsamość. Skontaktuj się z nami, aby uzyskać więcej informacji.',
    createVideoProject: 'Utwórz projekt wideo',
    creatingGame: 'Tworzenie Video Project...',
    dataIntegrationFailed:
      'Integracja danych nie powiodła się w %{vpName}. Przejdź do panelu integracji danych, sprawdź swoje pliki i spróbuj ponownie. Jeśli błąd będzie się powtarzał, skontaktuj się z zespołem pomocy Metrica Sports',
    dataIntegrationJobSuccess: 'Proces integracji danych dla %{vpName} został pomyślnie zakończony',
    date: 'Data',
    description: 'Opis',
    editedSuccessfully: '%{vpName} został pomyślnie edytowany',
    errorContactSupport: 'Błąd. Skontaktuj się z pomocą techniczną',
    errorProcessTooltip: 'Błąd w procesie',
    eventsDetection: 'Automatyczne tagowanie',
    eventsDetectionProcessedTooltip: 'Smart Tagging przetworzony',
    eventsDetectionTooltip: {
      footer: '*Dostępne dla filmów dłuższych niż 30 minut.',
      header:
        'Skorzystaj z naszej technologii, aby automatycznie wykrywać serię zdarzeń, które mają miejsce podczas meczu*.'
    },
    fieldRecognition: 'Wykrywanie pola gry',
    fieldTrackingProcessedTooltip: 'Przetworzono wykrywanie pola gry',
    fieldTrackingTooltip:
      'Przetwarzaj Wykrywanie Pola, aby dodać wizualizacje z wartościami prędkości i odległości oraz wszystkie rysunki zależne od pola w PlayBase.',
    fileDeletedSuccessfully: '%{fileName} został pomyślnie usunięty dla %{vpName}',
    fileUploadedError: 'Błąd podczas przesyłania %{fileName} dla %{vpName}',
    fileUploadedSuccessfully: '%{fileName} został pomyślnie przesłany do %{vpName}',
    forkedGameLimit: 'Ten projekt wideo należy do innej organizacji, więc nie można go modyfikować',
    gameDeletedSuccessfully: '%{game} usunięto pomyślnie',
    gameVideoProject: 'Projekt wideo',
    getMoreMinutes: 'Uzyskaj więcej',
    homeTeam: 'Drużyna gospodarzy',
    homeTeamScore: 'Wynik drużyny gospodarzy',
    initializing: 'Inicjowanie...',
    jobFailed:
      'Proces %{process} nie powiódł się dla %{vpName}. Skontaktuj się z zespołem pomocy Metrica Sports',
    liveCoding: 'czy kontynuować Coding na żywo?',
    liveCodingTooltip:
      'Możesz utworzyć projekt wideo bez wybierania pliku wideo do pracy w trybie Coding na żywo. Gdy masz już wideo, możesz je dodać, aby uzyskać Automatyczny Tracking Danych w danym projekcie wideo.',
    localTeamOnTheLeft:
      'Czy drużyna gospodarzy znajduje się po lewej stronie boiska w pierwszej połowie?',
    localTeamOnTheLeftTooltip:
      'Aby przetworzyć Automatyczne Tagowanie, określ, po której stronie boiska znajduje się każda drużyna. Sprawdź przesyłany film, aby go zweryfikować.',
    minutes: '%{minutes} Minut',
    noFootballSideViewTooltip:
      'Ten projekt wideo zawiera plik wideo niebędący nagraniem szerokokątnym ani nagraniem telewizyjnym, więc przetworzono tylko wykrywanie zawodników i drużyn.',
    noMatches: 'Brak meczów...',
    noSubscriptionOwnerTooltip:
      "Skontaktuj się z '%{email} ' (Admin Twojej subskrypcji), aby uaktualnić plan, lub przejdź do sekcji Plany na naszej stronie, aby utworzyć własną opcję",
    noVideoFile: 'Brak pliku wideo',
    notPossibleToDeleteThisEntry: 'Nie można usunąć tego wpisu',
    numberOfHalves: 'Na ile części podzielony jest ten mecz?',
    numberOfHalvesTooltip:
      'Aby przetworzyć Automatyczne Tagowanie, określ ile części gry jest uwzględnionych w przesyłanym filmie.',
    oldAtdTooltip: 'Ten film został przetworzony przy użyciu starszej wersji ATD',
    onRequest: 'Na życzenie',
    organizations: 'Organizacje',
    place: 'Miejsce',
    playerTracking: 'Wykrywanie Zawodników i Drużyny',
    playerTrackingProcessedTooltip: 'Przetworzono wykrywanie gracza',
    playerTrackingTooltip:
      'Ten proces wykryje bramkarzy i 10 zawodników polowych każdej drużyny. To pozwoli Ci na wizualizację Live Formation (boisko 2D) oraz automatyczne dodawanie wizualizacji graczy w PlayBase. Koordynaty graczy będą również dostępne w pliku formatu FIFA EPTS.',
    postProcessingData: 'Dalsze przetwarzanie danych...',
    preProcessingAtd: 'Wstępne przetwarzanie...',
    processingTooltip: 'Przetwarzanie',
    readyToUpload: 'Można rozpocząć przesyłanie',
    search: 'Szukaj...',
    selectVideoFile: 'Wybierz plik wideo',
    settingUpAtd: 'Konfigurowanie wykrywania...',
    settings: 'Ustawienia',
    singleVideoProject: 'Pojedynczy projekt wideo',
    startAtd: 'Rozpocznij ATD',
    startFifaMessage:
      'Proces integracji FIFA dla %{vpName} został rozpoczęty. Po zakończeniu wyświetlimy powiadomienie. Proszę czekać.',
    startProcessingWaitingJobsFailed: 'Wysyłanie zadań oczekujących nie powiodło się',
    startProcessingWaitingJobsSuccessfully: 'Zadania oczekujące wysłane pomyślnie',
    startSsMessage:
      'Rozpoczęła się integracja Second Spectrum dla %{vpName}. Po zakończeniu wyświetlimy stosowne powiadomienie. Proszę czekać.',
    startStatsMessage:
      'Rozpoczął się proces integracji "Stats" dla %{vpName}. Po zakończeniu wyświetlimy powiadomienie. Proszę czekać.',
    startTracabDflMessage:
      'Proces integracji Tracab DFL dla %{vpName} został rozpoczęty. Po zakończeniu wyświetlimy powiadomienie. Proszę czekać.',
    startTracabMessage:
      'Proces integracji Tracab dla %{vpName} został rozpoczęty. Po zakończeniu wyświetlimy powiadomienie. Proszę czekać.',
    surfacesJobSuccess: 'Diagnozowanie powierzchni w %{vpName} zakończyło się pomyślnie',
    trackingCorrectionProcessedTooltip: 'Tracking Correction processed',
    trackingFifaFormatJobSuccess:
      'Tracking formatu FIFA dla %{vpName} został pomyślnie zakończony. Możesz teraz pobrać plik, klikając pozycję "Pobierz format FIFA" w menu.',
    trackingLicence: 'Nie posiadasz licencji z trybem Tracking',
    uncaughtErrorRow:
      'Błąd projektu wideo. Proszę odśwież tę stronę. Jeśli problem będzie się powtarzał, skontaktuj się z pomocą techniczną, lub usuń go i utwórz ponownie',
    updatingGame: 'Aktualizowanie Video Project...',
    upgradePlan: 'Ulepsz',
    uploadAndTracking: 'Przesyłanie i Tracking',
    uploadingVideoFile: 'Przesyłanie pliku wideo',
    videoFile: 'Plik wideo',
    videoFootballSideView:
      'Czy ten plik wideo to szerokokątne lub telewizyjne nagranie meczu piłki nożnej?',
    videoFootballSideViewTooltip:
      'Wykrywanie pola jest zoptymalizowane tylko dla tego typu filmów.',
    videoMultipartStart:
      '%{videoName} jest przesyłany do %{vpName}. NIE ZAMYKAJ TEJ STRONY, dopóki przesyłanie nie zostanie zakończone',
    videoPlaylist: 'Czy ten plik wideo jest listą odtwarzania?',
    videoPlaylistTooltip:
      'Jeśli wybierzesz TAK, zostanie wykonana Detekcja Klipów, aby rozpoznać, kiedy następuje cięcie w filmie, co czyni ją idealnym narzędziem, jeśli przesyłasz film zawierający kilka klipów, na przykład. Po uruchomieniu tego procesu, pobierz Projekt Wideo w PlayBase, a znajdziesz tam plik Coding Detekcji Klipów z kodem zawierającym każde cięcie jako wydarzenie.',
    videoProjectSettings: 'Ustawienia projektu wideo',
    videoUploadError:
      'Przesyłanie wideo %{videoName} dla %{vpName} nie powiodło się. Proszę spróbuj ponownie',
    videoUploaded: '%{videoName} został przesłany na %{vpName}',
    vpCreated: '%{vpName} został utworzony',
    waitingAtd: 'Oczekiwanie...'
  },
  billing: {
    address: 'Adres',
    billed: 'Fakturowany',
    completed: 'Opłacony',
    details: 'Szczegóły Faktury',
    history: 'Historia Fakturowania',
    invoiceNotFound: 'Faktura nie znaleziona.',
    noInvoices: 'Brak faktur.',
    past_due: 'Przeterminowany',
    taxId: 'NIP'
  },
  checkout: {
    chargeSubscription: 'Obciążenie subskrypcji',
    costOneTime: '%{currency} %{cost}',
    costRecurrent: '%{currency} %{cost} %{cycle}',
    discountCodes: '*Kody rabatowe można zastosować przy kasie.',
    dueToday: 'Do zapłaty dzisiaj',
    excTax: '(Bez podatku)',
    halfYear: '6 miesięcy',
    halfYearlyBilled: 'Fakturowane co 6 miesięcy',
    immediatePayment: 'Natychmiastowa płatność',
    incTax: '(Brutto)',
    month: 'miesiąc',
    monthlyBilled: 'Rozliczane miesięcznie',
    nextPayment: 'Następna płatność',
    noPacks: 'Brak Minut GameCloud',
    onDate: 'dnia %{date}',
    packs: 'Pakiety',
    packsTotal: 'Pakiety Total',
    perHalfYear: '/6 miesięcy',
    perMonth: '/miesiąc',
    perYear: '/rok',
    plans: 'Plany',
    plansTotal: 'Łączna liczba planów',
    proceed: 'Przejdź do kasy',
    subtotal: 'Suma częściowa',
    taxPayable: 'Podatek do zapłaty (%{percentage}%)',
    total: 'Całkowity',
    unpaid:
      'Twoja ostatnia faktura nie została jeszcze opłacona. Proszę zaktualizuj swoje informacje płatnicze, aby kontynuować.',
    updatePaymentMethod: 'Aktualizuj metodę płatności',
    updateSubscription: 'Aktualizuj subskrypcję',
    upgradeTo: 'Aktualizuj do %{plan}',
    userDevice: '1 użytkownik/urządzenie',
    usersDevices: '%{number} użytkowników/urządzeń',
    year: 'rok',
    yearlyBilled: 'Rocznie fakturowane'
  },
  common: {
    add: 'Dodaj',
    back: 'Cofnij',
    cancel: 'Anuluj',
    canceling: 'Anulowanie...',
    clearAll: 'Wyczyść wszystko',
    continue: 'Kontynuować',
    create: 'Utwórz',
    deactivate: 'Dezaktywować',
    edit: 'Edytuj',
    email: 'E-mail',
    errorMsg:
      'Błąd przetwarzania %{name}. W przypadku pytań prosimy o kontakt z pomocą techniczną.',
    errorTryAgain: 'Błąd. Spróbuj ponownie',
    genericError:
      'Błąd, proces nie powiódł się. W przypadku pytań prosimy o kontakt z pomocą techniczną.',
    loading: 'Ładowanie...',
    login: 'Zaloguj się',
    logout: 'Wyloguj',
    new: 'Nowy',
    next: 'Kolejny',
    no: 'Nie',
    noFileChosen: 'Nie wybrano żadnego pliku',
    ok: 'Ok',
    pending: 'oczekujące',
    required: 'Wymagane',
    reset: 'Zresetuj hasło',
    restart: 'Uruchom ponownie',
    save: 'Zapisz',
    selectFile: 'Wybierz plik',
    sort: 'Sortuj',
    start: 'Rozpocznij',
    today: 'Dziś',
    unassigned: 'Nieprzypisane',
    uploading: 'Przesyłanie...',
    yes: 'Tak'
  },
  confirmModal: {
    description: 'Jesteś pewien?',
    title: 'Potwierdź'
  },
  container: {
    download: 'Pobierz Plik Kontenera',
    notProcessed: 'Plik Contenedor nie został przetworzony w tym Projekcie Wideo.',
    processed: 'Plik Kontenera przetworzony',
    title: 'Kontener',
    titleDownload: 'Pobierz Kontener'
  },
  dataIntegration: {
    deleteFile: 'Usuń plik',
    featureNotAvailable:
      'Ta funkcja nie jest dostępna w bieżącym planie. Aby mieć tę funkcję, musisz przejść na inny plan. Skontaktuj się z nami, aby uzyskać więcej informacji',
    notSideView:
      'Integracja danych nie jest dostępna w projektach wideo zawierających plik wideo inny niż szerokokątne, lub telewizyjne nagranie meczu.',
    open: 'Otwarta integracja danych',
    processJobsFirst:
      'Musisz najpierw rozpocząć Automatyczny Tracking Danych (ATD), zanim uzyskasz dostęp do panelu integracji danych',
    processed: 'Integracja danych przetworzona',
    selectFile: 'Wybierz plik',
    startProcess: 'Rozpocznij proces',
    title: 'Integracja danych',
    waiting: 'Proces oczekiwania...',
    waitingProcess:
      'Proces integracji rozpocznie się po zakończeniu procesów wykrywania zawodników i pola gry.'
  },
  deleteModal: {
    checkboxLabel: 'Chcę również przestać otrzymywać e-maile od Metrica Sports',
    confirmationType: 'Wpisz %{validateFormKey}, aby potwierdzić:',
    deleteAction: 'Tak, usuń to',
    description: 'Czy na pewno chcesz trwale usunąć swoje konto?',
    information:
      'Utracisz wszystkie projekty wideo utworzone za pomocą tego konta. Nie możemy ich odzyskać po usunięciu.',
    keepAccount: 'Zachowaj konto',
    suggestion: 'Sugerujemy, aby zachować swoje konto.',
    title: 'Usunąć ostatecznie?',
    validateFormKey: 'USUŃ'
  },
  error: {
    oops: 'UUPS!',
    restart: 'Wygląda na to, że próbujesz dostać się do obszaru, nad którym wciąż pracujemy...'
  },
  eventsDetection: {
    automaticVp: 'Smart Tagging nie jest dostępne w Projektach Wideo z starszą wersją ATD.',
    download: 'Pobierz wydarzenia Smart Tagging w formacie XML',
    needsAtd: 'Rozpocznij najpierw proces ATD, aby móc uruchomić proces Smart Tagging.',
    needsFootballSideView:
      'Smart Tagging nie jest dostępne w Projektach Wideo zawierających plik wideo z szerokokątnym ujęciem lub transmisją telewizyjną, które nie dotyczą piłki nożnej.',
    needsGameVp: 'Smart Tagging jest dostępny tylko w Projektach Wideo Meczowych.',
    needsNoPlaylist:
      'Smart Tagging nie jest dostępne w Projektach Wideo zawierających plik wideo będący listą odtwarzania.'
  },
  forgotPassword: {
    adminNoResetPassword:
      'Użytkownicy o statusie "Admin" muszą używać prywatnego punktu końcowego do resetowania hasła',
    notFound: 'Użytkownik nie został znaleziony. Spróbuj ponownie, podając prawidłowy adres e-mail',
    success: 'Hasła zresetowane! Proszę sprawdzić pocztę'
  },
  groups: {
    addMembers: 'Dodaj członków',
    addOrUpdateErrorMessage:
      'Błąd przetwarzania grupy. Jeśli problem będzie się powtarzał, skontaktuj się z zespołem wsparcia Metrica Sports',
    availableMinutes: 'Dostępne Minuty',
    availableMinutesWarning: 'Masz %{availableMinutes} minut do przypisania do jakiejś organizacji',
    createGroup: 'Utwórz Grupę',
    deleteErrorMessage:
      'Błąd podczas usuwania grupy. Jeśli problem będzie się powtarzał, skontaktuj się z zespołem wsparcia Metrica Sports',
    deleteGroup: 'Usuń Grupę',
    deleteGroupDescription:
      'Próbujesz usunąć grupę %{pre}%{name}%{post}. Jeśli jakikolwiek Projekt Wideo jest powiązany z tą grupą, użytkownicy nie będą mieli do niego już dostępu.',
    deleteNow: 'Usuń teraz',
    deleteThisGroup: 'Usuń tę grupę',
    editGroup: 'Edytuj Grupę',
    enterEmails: 'Wprowadź adresy e-mail użytkowników, których chcesz dodać',
    enterGroupName: 'Wprowadź nazwę grupy',
    enterValidName: 'Proszę, wprowadź prawidłowe imię',
    gameCloudMinutes: 'Minuty GameCloud',
    groupMembers: 'Członkowie grupy',
    groupName: 'Nazwa grupy',
    manageGameCloudMinutes: 'Zarządzaj Minutami GameCloud',
    minutesErrorMessage:
      'Błąd zarządzania minutami. Jeśli problem będzie się powtarzał, skontaktuj się z zespołem wsparcia Metrica Sports',
    moreLicensesDescription:
      'Aby dodać użytkowników z licencją do Twojego konta, proszę, kup więcej licencji',
    name: 'Nazwa Grupy',
    noMultiLicenseDescription: 'Tylko plany wielolicencyjne mogą tworzyć grupy',
    noPermissionDescription:
      'Twój użytkownik należy do organizacji %{pre}%{ownerEmail}%{post}, skontaktuj się z właścicielem, aby dokonać aktualizacji lub wprowadzić jakiekolwiek zmiany'
  },
  login: {
    clickHere: 'Kliknij tutaj',
    contactUs: 'Skontaktuj się z nami',
    dontHaveAccount: 'Nie mam konta. %{pre}Zarejestruj się%{post}',
    enterYourEmail: 'Wpisz swój e-mail',
    enterYourPassword: 'Wprowadź hasło',
    forgotPassword: 'Zapomniałem mojego hasła. %{pre}Kliknij Tutaj%{post}',
    invalidEmail: 'Nieprawidłowy adres e-mail',
    licenceExpired: 'Twoja licencja wygasła.',
    trialExpired: 'Twój okres "trial\' upłynął.',
    upgradePlan: 'Uaktualnij swój plan'
  },
  patterns: {
    delete: 'Usuń plik wzorca',
    title: 'Niestandardowy plik wzoru',
    upload: 'Prześlij plik niestandardowego wzoru',
    uploaded: 'Przesłano plik wzorca',
    uploading: 'Przesyłanie pliku wzorca'
  },
  plans: {
    academic: 'Academic',
    addMoreProducts: '+ Dodaj więcej produktów',
    admin: 'Admin',
    basic: 'Basic',
    basicCodePadMonthly: 'Basic+Code - Miesięczny',
    basicCodePadYearly: 'Basic+Code - Roczny',
    basicMftCodePadMonthly: 'Full Basic - Miesięcznie',
    basicMftCodePadYearly: 'Full Basic - Roczny',
    basicMftMonthly: 'Basic+MFT - Miesięczny',
    basicMftXmlMonthly: 'Basic MFT + XML - Miesięczny',
    basicMftXmlYearly: 'Basic MFT + XML - Roczny',
    basicMftYearly: 'Basic+MFT - Roczny',
    basicMonthly: 'Basic - Miesięczny',
    basicXmlMonthly: 'Basic XML - Miesięczny',
    basicXmlYearly: 'Basic XML - Roczny',
    basicYearly: 'Basic - Roczny',
    code: 'Code',
    elite: 'Elite',
    elite2024Yearly: 'Elite roczny',
    eliteYearly: 'Elite - Roczny',
    essentialsCodeMonthly: 'Essentials + Code ∞ Miesięczny',
    essentialsCodeYearly: 'Essentials + Code ∞ Roczny',
    essentialsMftCodeMonthly: 'Full Essentials Miesięczny',
    essentialsMftCodeYearly: 'Full Essentials Roczny',
    essentialsMftMonthly: 'Essentials + MFT Miesięczny',
    essentialsMftYearly: 'Essentials + MFT Roczny',
    essentialsMonthly: 'Essentials Miesięczny',
    essentialsYearly: 'Essentials Roczny',
    influencer: 'Influencer',
    lite: 'Lite',
    liteMonthly: 'Lite - Miesięczny',
    liteYearly: 'Lite - Roczny',
    minutes10: '10 Minut GameCloud',
    minutes100: '100 Minut GameCloud',
    minutes1000: '1.000 Minut GameCloud',
    minutes10000: '10.000 Minut GameCloud',
    plan: 'Plan %{planName}',
    planHalfYearly: 'Plan %{planName} Półroczny',
    planMonthly: 'Plan Miesięczny %{planName}',
    planYearly: 'Plan %{planName} Roczny',
    primeLiveMonthly: 'Prime + Live Miesięczny',
    primeLiveYearly: 'Prime + Live Roczny',
    primeMftLiveMonthly: 'Prime + MFT + Live Miesięczny',
    primeMftLiveYearly: 'Prime + MFT + Live Roczny',
    primeMftMonthly: 'Prime + MFT Miesięczny',
    primeMftYearly: 'Prime + MFT Roczny',
    primeMonthly: 'Prime Miesięczny',
    primePresetsLiveMonthly: 'Prime + Presets + Live Miesięcznie',
    primePresetsLiveYearly: 'Prime + Presets + Live Roczny',
    primePresetsMftLiveMonthly: 'Full Prime Miesięczny',
    primePresetsMftLiveYearly: 'Full Prime Roczny',
    primePresetsMftMonthly: 'Prime + Presets + MFT Miesięczny',
    primePresetsMftYearly: 'Prime + Presets + MFT Roczną',
    primePresetsMonthly: 'Prime + Presets Miesięczny',
    primePresetsYearly: 'Prime + Presets Roczny',
    primeYearly: 'Prime roczny',
    pro: 'Pro',
    pro2024LiveMonthly: 'Pro + Live Miesięczny',
    pro2024LiveYearly: 'Pro + Live Roczny',
    pro2024Monthly: 'Pro Miesięczny',
    pro2024Yearly: 'Pro rocznie',
    proYearly: 'Pro - Roczny',
    starter: 'Starter',
    starterCodeMonthly: 'Starter + Code ∞ Miesięczny',
    starterCodePadMonthly: 'Code - Miesięczny',
    starterCodePauseMonthly: 'Full Starter Miesięczny',
    starterCodePauseYearly: 'Full Starter Roczny',
    starterCodeYearly: 'Starter + Code ∞ Rocznik',
    starterPauseMonthly: 'Starter + Pause ∞ Miesięczny',
    starterPauseYearly: 'Starter + Pause ∞ Roczny',
    student: 'Student',
    trial: 'Trial'
  },
  playlist: {
    download: 'Pobierz plik playlisty',
    notProcessed: 'Playlista nie została processed w tym Video Project.',
    processed: 'Plik playlisty processed',
    title: 'Playlist',
    titleDownload: 'Pobierz playlistę'
  },
  products: {
    addOns: 'Dodatki',
    basic: 'Nieograniczone Kody i Adnotacje',
    code: 'CodePad',
    elite: {
      description:
        'Automatyzuj i dostosuj cały swój proces analizy. Ten plan obejmuje pełny dostęp do PlayBase ze wszystkimi funkcjami Planu "Full Essentials" oraz dostęp do Metrica Nexus ze wszystkimi funkcjami Planu "Pro".',
      feature1: '✓ Współdzielone przechowywanie w Chmurze',
      feature2: '✓ Integracja Danych Trackingowych',
      feature3: '✓ Menadżer Korekty Śledzenia',
      feature4: '✓ RESTful API'
    },
    essentials: {
      addon1: 'Nieograniczone funkcje Coding (CodePad, Live Coding i Import XML)',
      addon2: 'Manualne Śledzenie na Boisku',
      essentialsCodeDescription:
        'Ten plan umożliwia korzystanie z Dynamicznych Telestracji, pozwalając na dodawanie nieograniczonych wizualizacji ruchu podczas odtwarzania wideo oraz w pauzach. Plan ten nie obejmuje Ręcznego Śledzenia Pola, więc wizualizacje Prędkości i Dystansu nie są włączone. Ponadto, odblokowuje ograniczenia funkcji kodowania takich jak CodePad, Kodowanie na Żywo i Import XML, oraz znosi ograniczenie do 4 kodów na Projekt Wideo, umożliwiając korzystanie z nieograniczonej liczby kodów.',
      essentialsDescription:
        'Ten plan umożliwia korzystanie z Dynamic Telestration, co pozwala na dodawanie nieograniczonych wizualizacji ruchu podczas odtwarzania wideo oraz w przerwach. Ten plan nie obejmuje Manual Field Tracking, więc wizualizacje Prędkości i Dystansu nie są włączone. Funkcje kodowania pozostają ograniczone.',
      essentialsMftCodeDescription:
        'Ten plan umożliwia korzystanie z Dynamicznych Telestracji, pozwalając na dodawanie nieograniczonych wizualizacji ruchu podczas odtwarzania wideo i w pauzach, oraz aktywuje Manuel Field Tracking do dodawania wizualizacji prędkości i dystansu. Ponadto usuwa ograniczenie funkcji kodowania takich jak CodePad, Live Coding i Import XML, oraz znosi limit 4 kodów na Projekt Wideo na nieograniczoną liczbę kodów.',
      essentialsMftDescription:
        'Ten plan umożliwia korzystanie z Dynamicznych Telestracji, pozwalając na dodawanie nieograniczonych wizualizacji ruchu podczas odtwarzania wideo i w przerwach, oraz aktywuje Ręczne Śledzenie na Boisku, aby dodawać wizualizacje prędkości i dystansu. Funkcje kodowania pozostają ograniczone.',
      feature1: '✓ Kodowanie po meczu (Code Table z maksymalnie 4 kodami)',
      feature2: '✓ Nieograniczone telestracje podczas pauzy',
      feature3: '✓ Dynamiczne Telestracje'
    },
    featuresIncluded: 'Dołączone funkcje:',
    freeFeature1: '✓ Kodowanie po meczu (Code Table z maksymalnie 4 kodami)',
    freeFeature2: '✓ Ręczne śledzenie',
    freeFeature3: '✓ Telestracja (do 50 adnotacji)',
    freeFeature4: '✓ Eksport wideo',
    freeFeatures: 'Darmowe Funkcje',
    fullBasic: 'Manualne Śledzenie na Boisku',
    lite: 'Automatyczne Śledzenie Graczy i Boiska',
    liteDescription:
      'Zaawansowane kodowanie i zaawansowane wizualizacje. Wszystko automatycznie, co czyni to 3 razy szybszym niż Full Basic!',
    minutesDescription:
      'Doładuj dowolny plan. Zdobądź pakiety minut dla Automatycznego Śledzenia Danych (ATD).',
    minutesPack: 'Pakiet Minut GameCloud',
    nexus_elite: {
      description: 'Dla najlepszych drużyn na świecie',
      feature1: '✓ Wszystkie funkcje Pro',
      feature2: '✓ Pełne Tracking Clipu',
      feature3: '✓ Nexus Live (Nagrywanie na Żywo + Nexus Mobile)'
    },
    nexus_prime: {
      addon1: 'Nexus Live (Nagrywanie na Żywo + Nexus Mobile)',
      description: 'Rozwiązanie Podstawowe',
      feature1: '✓ Pełna Analiza Meczu',
      feature2: '✓ Pełne Telestration',
      feature3: '✓ Manualne Tracking'
    },
    nexus_pro: {
      addon1: 'Nexus Live (Nagrywanie na Żywo + Nexus Mobile)',
      description: 'Automatyzuj swój Workflow',
      feature1: '✓ Pełna Analiza Meczu',
      feature2: '✓ Pełne Telestration',
      feature3: '✓ Automatyczne Tracking'
    },
    otherDescription:
      'Zaawansowane funkcje kodowania z podstawową telestracją i ograniczonymi adnotacjami.',
    playbase_advanced: {
      description: 'Całkowicie zautomatyzowana analiza',
      feature1: '✓ Pełna Analiza Meczu',
      feature2: '✓ Telestracja w Ruchu',
      feature3: '✓ Automatyczne Tracking'
    },
    playbase_essentials: {
      description: 'Rozwiązanie Podstawowe',
      feature1: '✓ Pełna Analiza Meczu',
      feature2: '✓ Telestracja na Pauzach'
    },
    playbase_plus: {
      description: 'Tracking na własnym tempie',
      feature1: '✓ Pełna Analiza Meczu',
      feature2: '✓ Telestracja w Ruchu',
      feature3: '✓ Manualne Tracking'
    },
    prime: {
      addon1: 'Manualne Śledzenie na Boisku',
      addon2: 'Własne Wizualizacje (dostosuj i zapisz swoje własne wizualizacje)',
      addon3: 'Nagrywanie Na Żywo (capture, analyze, i share highlights w trakcie)',
      feature1: '✓ Pełny dostęp do PlayBase ze wszystkimi funkcjami planu "Full Essentials"',
      feature2: '✓ Dostęp do Metrica Nexus z:',
      feature2_1: 'Sekwencyjne pauzy',
      feature2_2: 'Zaawansowane telestracje',
      feature2_3: 'Eksport niestandardowych wideo',
      primeDescription:
        'Ten plan zapewnia pełny dostęp do PlayBase ze wszystkimi funkcjami planu "Essentials + Code ∞" oraz umożliwia korzystanie z Metrica Nexus z zaawansowanymi narzędziami do telestracji.',
      primeMftDescription:
        'Ten plan zapewnia pełny dostęp do PlayBase ze wszystkimi funkcjami planu "Full Essentials" oraz umożliwia korzystanie z Metrica Nexus z zaawansowanymi narzędziami do telestracji.',
      primePresetsDescription:
        'Ten plan zapewnia pełny dostęp do PlayBase ze wszystkimi funkcjami planu "Essentials + Code ∞" oraz umożliwia korzystanie z Metrica Nexus z zaawansowanymi narzędziami do telestracji i personalizowanymi wizualizacjami.',
      primePresetsMftDescription:
        'Ten plan zapewnia pełny dostęp do PlayBase ze wszystkimi funkcjami planu "Full Essentials" oraz umożliwia korzystanie z Metrica Nexus z zaawansowanymi narzędziami do telestracji i personalizowanymi wizualizacjami.'
    },
    pro: {
      addon1: 'Nagrywanie Na Żywo (capture, analyze, i share highlights w trakcie)',
      description:
        'Ten plan zapewnia pełny dostęp do PlayBase ze wszystkimi funkcjami planu "Full Essentials" oraz dostęp do Metrica Nexus ze wszystkimi funkcjami planu "Full Prime".',
      feature1: '✓ Automatyczne Śledzenie Graczy',
      feature2: '✓ Automatyczne Śledzenie Pola',
      feature3: '✓ Pełny dostęp do PlayBase ze wszystkimi funkcjami Planu "Full Essentials"',
      feature4: '✓ Dostęp do Metrica Nexus z:',
      feature4_1: 'Sekwencyjne pauzy',
      feature4_2: 'Zaawansowane Telestracje',
      feature4_3: 'Eksport niestandardowych wideo',
      feature4_4: 'Własne Wizualizacje (dostosuj i zapisz swoje własne wizualizacje)'
    },
    remove: 'Usunąć',
    starter: {
      addon1: 'Nielimitowane telestracje podczas pauz',
      addon2: 'Nieograniczone funkcje Coding (CodePad, Live Coding i Import XML)',
      feature1: '✓ Kodowanie po meczu (Code Table z maksymalnie 4 kodami)',
      feature2: '✓ Telestracja podczas pauz (do 50 adnotacji miesięcznie)',
      feature3: '✓ Eksport wideo',
      starterCodeDescription:
        'Ten plan znosi ograniczenia funkcji kodowania takich jak CodePad, Kodowanie na Żywo i Import XML. Znosi również ograniczenie do 4 kodów na Projekt Wideo, umożliwiając ich nieograniczoną liczbę. Ograniczenia funkcji telestracji pozostają jak w Free Starter.',
      starterCodePauseDescription:
        'Ten plan odblokowuje ograniczenia funkcji kodowania takich jak CodePad, Kodowanie na Żywo i Import XML. Znosi również limit 4 kodów na Projekt Wideo na nieograniczoną liczbę kodów oraz odblokowuje ograniczenie telestracji w pauzach z 50 na miesiąc do nieograniczonej liczby.',
      starterPauseDescription:
        'Ten plan znosi ograniczenie telestracji w pauzach z 50 miesięcznie do nieograniczonych. Ograniczenia funkcji coding pozostają jak w Free Starter.'
    },
    totalPack: '%{currency} %{cost}'
  },
  settings: {
    billing: 'Fakturowanie',
    billingSettings: 'Ustawienia płatności',
    billingSettingsDescription: '(zmień swój plan, zaktualizuj metody płatności...)',
    cancelAt: 'Twój plan zostanie anulowany w dniu',
    cancelPlan: 'Anuluj plan',
    confirmNewPassword: 'Potwierdź nowe hasło',
    deleteAccount: 'Usuń konto',
    details: 'Moje dane',
    devices: 'Urządzenia',
    devicesResetError: 'Błąd podczas resetowania urządzeń. Proszę spróbuj ponownie',
    devicesResetSuccess: 'Wszystkie Twoje urządzenia zostały pomyślnie zresetowane',
    emailNotActivated: 'Powiadomienie e-mail jest teraz aktywne',
    emailNotDeactivated: 'Powiadomienie e-mail jest teraz wyłączone',
    emailNotifications: 'powiadomienia e-mailowe',
    groups: 'Grupy',
    language: 'Język',
    languageChanged: 'Język został zaktualizowany',
    manualResetDevices: 'Skontaktuj się z pomocą techniczną, aby zresetować swoje urządzenia',
    newPassword: 'Nowe hasło',
    noDevicesToReset: 'Brak urządzeń do zresetowania',
    noOwner:
      'Twój Plan należy do organizacji %{pre}%{email}%{post}, skontaktuj się z właścicielem, aby dokonać aktualizacji lub wprowadzić jakiekolwiek zmiany',
    organizationLabel: 'Prefiks organizacji',
    organizationTooltip:
      'Ten prefiks jest potrzebny do importowania niestandardowych wzorów do projektu wideo. Skontaktuj się z nami, aby uzyskać więcej informacji, lub sprawdź dokumentację na codeball.metrica-sports.com',
    passwordsDontMatch: 'Hasła nie są identyczne',
    passwordInvalid: 'Hasło nie spełnia wymagań',
    passwordRequirements: {
      minLength: 'Co najmniej %{count} znaków',
      uppercase: 'Jedna wielka litera',
      lowercase: 'Jedna mała litera',
      number: 'Jedna cyfra (0-9)',
      maxLength: 'Maksymalna liczba znaków: %{count}'
    },
    pauseAt: 'Twój plan zostaje wstrzymany dnia',
    planCanceled:
      'Twój plan został anulowany. Sprawdź pocztę e-mail, aby uzyskać więcej informacji',
    plans: 'Plany',
    quantity: 'Ilość:',
    remainingResets: '%{current}/%{max} przełączeń pozostałych w tym roku',
    renewAt: 'Twój plan odnawia się w dniu',
    resetDeviceAction: 'Resetowanie Urządzeń',
    title: 'Ustawienia',
    upgradePlan: 'Aktualizuj Plan',
    userKey: 'Klucz użytkownika:',
    userKeyUsages: '%{current}/%{max} zużycia',
    userSettings: 'Ustawienia użytkownika',
    users: 'Użytkownicy'
  },
  shoppingCart: {
    subtitle: 'Wybierz swój plan Metrica Sports i dodatki, aby podnieść swoje wyniki.',
    title: 'Skonfiguruj swoje Metrica Sports'
  },
  subscription: {
    cancelSubscription: 'Anuluj subskrypcję',
    errorUpdating:
      'Wystąpił błąd podczas aktualizacji twojej subskrypcji. Proszę, wyślij e-mail na adres support@metrica-sports.com, a z przyjemnością Ci pomożemy.',
    free: 'Darmowy',
    isObsolete:
      'Twoja subskrypcja nie może zostać zmodyfikowana. Zastąp przestarzałe produkty nowymi, aby umożliwić zmiany.',
    pendingRefundRequest:
      'Nie można dokonywać dalszych zmian w tej subskrypcji, dopóki istnieje oczekujące żądanie zwrotu pieniędzy.',
    planMigrationMessage:
      "Od 1 kwietnia Twoja subskrypcja <strong>%{currentPlan}</strong> będzie nazywać się <strong>%{newPlan}</strong>, ale nie zostanie Ci niczego naliczone. Nie wymaga to żadnych działań z Twojej strony. <strong>%{date}</strong>, cena Twojego planu wyniesie <strong>%{newPrice}</strong> za użytkownika, za <strong>%{cycle}</strong>. Aby dowiedzieć się więcej o wszystkich nowych planach <a href='%{link}'>kliknij tutaj</a>.",
    undoCancel: 'Cofnij anulowanie subskrypcji.',
    undoPause: 'Cofnij wstrzymanie subskrypcji.',
    updatePaymentMethod: 'Aktualizuj metodę płatności',
    updatedSuccessfully: 'Subskrypcja została pomyślnie zaktualizowana.',
    yourPlans: 'Twoje Plany',
    yourSubscription: 'Twoja Subskrypcja'
  },
  successfulPayment: {
    addUsers: 'Dodaj innych użytkowników do swojej organizacji.',
    allTheBest: 'Wszystkiego najlepszego,',
    applyKey: 'Zastosuj klucz do tego konta.',
    applyKeyDescription: 'Czy chciałbyś aktywować tę licencję dla swojego konta?',
    assignLicenses: 'Przenieś swoją licencję na inne konto.',
    download:
      'Przejdź do %{pre}Strony Pobierania%{post} na naszej stronie internetowej i pobierz PlayBase lub Nexus, w zależności od Twojej licencji.',
    faq: 'Oto jak szybko zacząć i inne istotne informacje:',
    happyPlay:
      'Mamy nadzieję, że wszystko jest jasne, ale prosimy, nie wahaj się skontaktować z nami, jeśli masz więcej pytań lub wątpliwości.',
    helpCenter:
      'Sprawdź nasze %{pre}Centro de Ayuda%{post} po wiele pomocnych artykułów, takich jak pełne tutoriale i często zadawane pytania.',
    howToCancel:
      'Proszę zauważyć, że Twoja subskrypcja jest odnawiana automatycznie do czasu, aż zostanie %{pre}anulowana wyraźnie za pośrednictwem ustawień GameCloud%{post}, zgodnie z naszymi Warunkami i Zasadami.',
    keyApplied: 'Klucz zastosowany',
    licenseActivation1:
      'Jeśli jeszcze nie miałeś aktywnej licencji na swoje konto, Twoja nowo zakupiona licencja została aktywowana automatycznie.',
    licenseActivation2:
      'Jeśli Twoja licencja nie została aktywowana z jakiegokolwiek powodu, możesz ją aktywować poniżej:',
    licenseKey: 'Twój klucz licencyjny to: %{pre}%{licenseKey}%{post}.',
    licensesTitle: 'Aktywacja Licencji',
    metricaSportsTeam: '— Zespół Metrica Sports',
    minutesInfo:
      'Jeśli chcesz rozdzielić swoje minuty GameCloud między różne grupy użytkowników, przejdź do zakładki Grupy w %{pre}Stronie Ustawień%{post}.',
    minutesTitle: 'Twoje Minuty GameCloud',
    renewalInfo:
      'Proszę zauważyć, że Twoja subskrypcja jest automatycznie odnawiana do czasu, aż zostanie %{pre}anulowana wyraźnie za pośrednictwem ustawień GameCloud%{post}, zgodnie z naszymi Warunkami Użytkowania.',
    settingsCloud: 'Odwiedź nasz %{pre}GameCloud%{post} i przejdź do menu Ustawienia, aby:',
    technicalSupport:
      'W przypadku wsparcia technicznego, %{pre}skontaktuj się z nami%{post} bezpośrednio.',
    thanks: 'Dziękujemy za Twoje zamówienie, zostało ono pomyślnie przetworzone!',
    title: 'Potwierdzenie zamówienia',
    updatePayment: 'Zaktualizuj metodę płatności.',
    updateSubscription: 'Anuluj lub zmodyfikuj swoją subskrypcję.'
  },
  surfaces: {
    automaticVp: 'Powierzchnie niedostępne w projektach wideo ze starszą wersją ATD',
    delete: 'Usuń plik powierzchni pola gry',
    needsAtd:
      'Najpierw uruchom ATD, aby uruchomić procesy związane z diagnozą powierzchni pola gry',
    needsElite:
      'Niestandardowe powierzchnie są dostępne w abonamencie Elite. Skontaktuj się z nami, aby uzyskać więcej informacji',
    needsFootballSideView:
      'Diagnoza powierzchni pola gry nie jest dostępna w projektach wideo zawierających plik wideo inny niż szerokokątne, lub telewizyjne nagranie meczu piłki nożnej',
    pitchControl:
      'Uruchomienie tego procesu pozwoli Ci dodać wizualizację Pitch Control w PlayBase.',
    pitchControlProcessed: 'Tryb "Pitch Control" dla tej powierzchni został przetworzony',
    pitchControlProcessing: 'Pitch Control - przetwarzanie',
    processed: 'Przesłano plik związany z powierzchnią pola gry',
    processing: 'Przetwarzanie pliku związanego z powierzchnią pola gry',
    title: 'Powierzchnie pola gry',
    titlePitchControl: 'Pitch Control',
    upload: 'Prześlij swoją własną powierzchnię pola gry',
    uploading: 'Przesyłanie powierzchni pola gry...'
  },
  trackingFifaFormat: {
    download: 'Pobierz plik w formacie FIFA EPTS',
    needsElite:
      'Ta funkcja jest dostępna tylko po zaimportowaniu odpowiednich plików do modułu integracji danych, projektów wideo zawierających Automatyczny Tracking Danych, lub projektów wideo w planie Elite.',
    processed: 'Przetworzono format FIFA EPTS',
    start:
      'Rozpocznij proces generowania pliku w formacie FIFA EPTS. Będziesz wtedy mógł pobrać plik',
    title: 'Format FIFA EPTS',
    titleDownload: 'Pobierz format FIFA EPTS'
  },
  upgradeModal: {
    linksDescription: 'Wybierz pakiet minut GameCloud, który najlepiej odpowiada Twoim potrzebom:',
    minutePackLinks: {
      minutes_10: 'Zdobądź 10 minut za 10 €',
      minutes_100: 'Zdobądź 100 minut za 90 €',
      minutes_1000: 'Zdobądź 1000 minut za 750€',
      minutes_10000: 'Zdobądź 10 000 minut za 5000 €'
    },
    noMinutes: {
      description:
        'Nie masz wystarczająco dużo dostępnych minut, aby utworzyć ten projekt wideo. Czy wiesz, że możesz zdobyć pakiety minutowe, niezależnie od twojego planu?',
      secondDescription: '',
      title: 'Uzyskaj więcej minut na utworzenie projektu wideo!'
    },
    notEnoughMinutes: {
      description:
        'Z przykrością informujemy, że nie masz wystarczająco dużo minut na przetworzenie ATD w swoich projektach wideo.',
      secondDescription:
        'Jeśli chcesz przetwarzać ATD, musisz dodać więcej minut do swojego konta. Minuty, które otrzymasz, nie wygasają!',
      title: 'Brak wystarczającej liczby dostępnych minut'
    }
  },
  users: {
    addEmails: 'Dodaj użytkowników z ich adresami e-mail',
    addErrorMessage:
      'Błąd podczas dodawania użytkowników. Jeśli problem będzie się powtarzał, skontaktuj się z zespołem wsparcia Metrica Sports',
    addUsers: 'Dodaj Użytkowników',
    availableLicenses: '%{planName} (%{count} dostępne%{renewal})',
    currentLicense: '%{planName} (obecny%{renewal})',
    deactivateErrorMessage:
      'Błąd dezaktywacji użytkownika. Jeśli problem będzie się powtarzał, skontaktuj się z zespołem wsparcia Metrica Sports',
    deactivateNow: 'Dezaktywuj teraz',
    deactivateUser: 'Dezaktywować Użytkownika',
    deactivateUserDescription:
      'Próbujesz dezaktywować użytkownika %{pre}%{email}%{post}. Użytkownik nie będzie mógł uzyskać dostępu do żadnej usługi Metrica Sports i zostanie zmieniony na plan Free.',
    editUser: 'Edytuj Użytkownika',
    enterGroup: 'Wprowadź Grupę',
    exportUsers: 'Eksportuj Użytkowników',
    filteredUsers: '%{nUsers} z %{totalUsers} użytkowników',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    plan: 'Plan',
    renewsOn: ', odnawia się %{date}',
    role: 'Rola',
    roles: {
      admin: 'Administrator',
      member: 'Członek',
      owner: 'Właściciel'
    },
    unlinkErrorMessage:
      'Błąd podczas odłączania użytkownika. Jeśli problem będzie się powtarzał, skontaktuj się z zespołem wsparcia Metrica Sports',
    unlinkFromYourAccount: 'Odłącz od Twojego konta',
    unlinkNow: 'Odłącz teraz',
    unlinkUser: 'Odłącz Użytkownika',
    unlinkUserDescription:
      'Próbujesz odłączyć użytkownika %{pre}%{email}%{post}. Użytkownik nie będzie mógł uzyskać dostępu do żadnej usługi Metrica Sports i zostanie zmieniony na plan Free.',
    updateErrorMessage:
      'Błąd podczas aktualizacji użytkownika. Jeśli problem będzie się powtarzał, skontaktuj się z zespołem wsparcia Metrica Sports',
    useComma: 'Użyj przecinka, aby oddzielić różne adresy e-mail',
    userGroups: 'Grupy Użytkowników'
  },
  video: {
    cancelUpload: 'Anuluj przesyłanie',
    delete: 'Usuń film',
    download: 'Pobierz wideo',
    title: 'Plik wideo',
    upload: 'Prześlij wideo',
    uploaded: 'Przesłano film wideo',
    uploading: 'Przesyłanie wideo'
  },
  videoProject: {
    delete: 'Usuń projekt wideo',
    edit: 'Edytuj projekt wideo',
    processWaitingJobs: 'Przetwarzaj zadania oczekujące',
    title: 'Projekt wideo'
  }
}
